import React, { useMemo } from 'react';
import type { Lead } from '../../types';
import { parseInquireLeadNotes } from '../../utils/inquireLeadNotes';
import './InquireProjectInfo.css';

type Props = {
  lead: Pick<Lead, 'notes' | 'projectType' | 'budget' | 'timeline'>;
};

const InquireProjectInfo: React.FC<Props> = ({ lead }) => {
  const info = useMemo(() => parseInquireLeadNotes(lead.notes), [lead.notes]);
  const projectType = info.projectType || lead.projectType || '';
  const timeline = info.timeline || lead.timeline || '';
  const budgetLabel = info.budget || (lead.budget && lead.budget > 0 ? `$${lead.budget.toLocaleString()}` : '');
  const budgetAmount = info.budgetAmount ?? (lead.budget && lead.budget > 0 ? lead.budget : undefined);
  const readiness = info.readiness || '';
  const message = info.message || '';

  if (!info.fromInquireForm && !projectType && !timeline && !budgetLabel && !readiness && !message) {
    return null;
  }

  return (
    <section className="inquire-project-info" aria-label="Project info">
      <h3 className="inquire-project-info-title">Project info</h3>
      <dl className="inquire-project-info-grid">
        {projectType ? (
          <>
            <dt>Type</dt>
            <dd>{projectType}</dd>
          </>
        ) : null}
        {timeline ? (
          <>
            <dt>Timeline</dt>
            <dd>{timeline}</dd>
          </>
        ) : null}
        {budgetAmount && budgetAmount > 0 ? (
          <>
            <dt>Budget</dt>
            <dd>{budgetLabel || `$${budgetAmount.toLocaleString()}`}</dd>
          </>
        ) : null}
        {readiness ? (
          <>
            <dt>Readiness</dt>
            <dd>{readiness}</dd>
          </>
        ) : null}
      </dl>
      {message ? (
        <div className="inquire-project-info-message">
          <span className="inquire-project-info-message-label">Message</span>
          <p>{message}</p>
        </div>
      ) : null}
    </section>
  );
};

export default InquireProjectInfo;
